export const version = '3.3.0';
export const navbarBreakPoint = 'xl'; // Vertical navbar breakpoint
export const topNavbarBreakpoint = 'lg';
export const settings = {
  isFluid: true,
  isRTL: false,
  isDark: !localStorage.getItem('isDark')
    ? false
    : localStorage.getItem('isDark') === 'true'
    ? true
    : false,
  navbarPosition: 'vertical',
  showBurgerMenu: false, // controls showing vertical nav on mobile
  currency: '$',
  isNavbarVerticalCollapsed: false, // toggle vertical navbar collapse
  navbarStyle: 'vibrant'
};

export default { version, navbarBreakPoint, topNavbarBreakpoint, settings };
